import React from 'react';
import { Spring } from 'react-spring';
import Img from 'gatsby-image';
import { css } from 'emotion';
import styles from './project-hero-image.module.css';

const ProjectHeroImage = ({
  featuredImage,
  featuredMobileImage,
  browserDetect,
  isHome,
  returnSection,
}) => {
  const {
    originalImg: desktopFeaturedImgIE,
  } = featuredImage.localFile.childImageSharp.sizes;
  const {
    originalImg: mobileFeaturedImg,
  } = featuredMobileImage.localFile.childImageSharp.sizes;

  const defaultImgStyles = {
    transform: 'scale(1, 1)',
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
  };

  const renderDefaultImages = imgStyles => {
    return (
      <React.Fragment>
        <Img
          sizes={featuredImage.localFile.childImageSharp.sizes}
          backgroundColor={true}
          style={imgStyles}
          className={styles.desktopFeaturedImg}
        />
        <Img
          sizes={featuredMobileImage.localFile.childImageSharp.sizes}
          backgroundColor={true}
          style={imgStyles}
          className={styles.mobileFeaturedImg}
        />
      </React.Fragment>
    );
  };

  const renderHomeAnimation = () => {
    return (
      <Spring
        from={defaultImgStyles}
        to={{
          transform:
            returnSection === 'active' ? 'scale(1.05, 1.05)' : 'scale(1, 1)',
        }}
        delay={200}
        config={{ tension: 180, friction: 60 }}
      >
        {animation => renderDefaultImages(animation)}
      </Spring>
    );
  };

  const renderDefaultAnimation = () => {
    return renderDefaultImages(defaultImgStyles);
  };

  const renderIEImages = () => {
    return (
      <React.Fragment>
        <div
          className={[
            css`
              background-image: url(${desktopFeaturedImgIE});
            `,
            styles.desktopFeaturedImg,
            styles.desktopFeaturedImgIE,
          ].join(' ')}
        />
        <div
          className={[
            css`
              background-image: url(${mobileFeaturedImg});
            `,
            styles.mobileFeaturedImg,
            styles.mobileFeaturedImgIE,
          ].join(' ')}
        />
      </React.Fragment>
    );
  };

  const renderProjectHeroImages = () => {
    if (isHome !== true) {
      return renderDefaultAnimation();
    } else {
      return renderHomeAnimation();
    }
  };

  return (
    <React.Fragment>
      {browserDetect !== 'IE' ? renderProjectHeroImages() : renderIEImages()}
    </React.Fragment>
  );
};

export default ProjectHeroImage;



// WEBPACK FOOTER //
// ./src/components/project/project-hero/project-hero-image/index.js